export default {"src":"/_next/static/media/hero-bug-right.5afcc5fc.gif","height":400,"width":400};